import * as React from "react";
import UserData from "../../../../model/user/UserData";
import EditUserFormView from "./EditUserFormView";
import User from "../../../../model/user/User";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {changeUserSuspend, updateUser} from "../../../../store/action/user/user";
import Toast from "../../../helper/Toast";
import {none, Option, option} from "ts-option";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";

interface IComponentProps {
	/**
	 * On successful created user callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * User to edit
	 */
	user: User;
}

interface IDispatchProps {
	/**
	 * Update user.
	 * @param data
	 * @param file
	 * @param shouldRemoveFileOnUpdate
	 * @param onSuccess
	 * @param onFailure
	 */
	updateUser: (data: UserData,
		file: Option<File>,
		shouldRemoveFileOnUpdate: boolean,
		onSuccess: OnSuccess,
		onFailure: OnFailure) => void;
	/**
	 * Disable or enable user
	 * @param {string} userId
	 * @param {boolean} disabled
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	changeUserSuspend: (userId: string, disabled: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Image file of user
	 */
	file: Option<File>;
	/**
	 * Should remove file on update indicator
	 */
	shouldRemoveFileOnUpdate: boolean;
}

type Props = IComponentProps & IDispatchProps

class EditUserForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false, file: none, shouldRemoveFileOnUpdate: false};
		this.onSubmit = this.onSubmit.bind(this);
		this.onAddFile = this.onAddFile.bind(this);
		this.onRemoveFile = this.onRemoveFile.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitFailure = this.onSubmitFailure.bind(this);
	}

	render() {
		return (
			<EditUserFormView onSubmit={this.onSubmit}
							  onCancel={this.props.onCancel}
							  isSubmitting={this.state.isSubmitting}
							  onAddFile={this.onAddFile}
							  onRemoveFile={this.onRemoveFile}
							  user={this.props.user}/>
		);
	}

	onRemoveFile() {
		this.setState({file: none, shouldRemoveFileOnUpdate: true})
	}

	onAddFile(file: File) {
		this.setState({file: option(file), shouldRemoveFileOnUpdate: false})
	}

	onSubmit(data: UserData, password: string, disabled: boolean) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateUser(data, this.state.file, this.state.shouldRemoveFileOnUpdate, () => {
					if (this.props.user.disabled !== disabled) {
						this.props.changeUserSuspend(this.props.user.id, disabled, this.onSubmitSuccess, this.onSubmitFailure)
					}
					else {
						this.onSubmitSuccess()
					}
				},
				this.onSubmitFailure
			);
		});
	}

	onSubmitSuccess() {
		this.setState({isSubmitting: false}, () => {
			Toast.success("User updated", "User update");
			this.props.onSuccess();
		});
	}

	onSubmitFailure(error: any) {
		this.setState({isSubmitting: false}, () => notifyBugsnagAndShowToast(error, "User update"));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>, props: IComponentProps) {
	return {
		updateUser: (data: UserData,
			file: Option<File>,
			shouldRemoveFileOnUpdate: boolean,
			onSuccess: OnSuccess,
			onFailure: OnFailure) =>
			dispatch(updateUser(props.user.id, data, file, shouldRemoveFileOnUpdate, onSuccess, onFailure)),
		changeUserSuspend: (userId: string, disabled: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			changeUserSuspend(userId, disabled, onSuccess, onFailure)
		)

	};
}

export default connect(null, mapDispatchToProps)(EditUserForm);